import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { ShoppingCart } from "lucide-react";
import { NavLink } from "react-router-dom";
import Button from "./Button";
import logo from "../assets/logo.png";
import { apiRequest } from "../api/client";
import { useCart } from "../context/CartContext";

const defaultPromoStrip = ["Limited offer: 20% this week", "Use LAUNCH20", "Digital access"];

function getPromoStrip(settings) {
  const configured = settings?.content?.promo_strip;
  return (Array.isArray(configured) ? configured : defaultPromoStrip)
    .map((item) => String(item || "").trim())
    .filter(Boolean);
}

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [settings, setSettings] = useState(null);
  const cart = useCart();
  const promoStrip = getPromoStrip(settings);

  useEffect(() => {
    let mounted = true;
    apiRequest("/api/settings/public")
      .then((response) => {
        if (mounted) setSettings(response.data);
      })
      .catch(() => {});

    return () => {
      mounted = false;
    };
  }, []);

  const navItems = [
    { label: "Home", path: "/" },
    { label: "Shop", path: "/shop" },
    { label: "About Me", path: "/about" },
    { label: "Contact Me", path: "/contact" },
    { label: "Account", path: "/account" },
  ];

  const links = navItems.map((link) => link.hash ? (
    <a key={link.label} href={link.hash} onClick={() => setOpen(false)}>
      {link.label}
    </a>
  ) : (
    <NavLink key={link.label} to={link.path} end={link.path === "/"} onClick={() => setOpen(false)}>
      {link.label}
    </NavLink>
  ));

  return (
    <header className="site-header">
      <nav className="container nav">
        <NavLink to="/" className="logo" aria-label="Moataz Hafez home">
          <img src={logo} alt=""  style={{width:"80px", height:"80px"}}/>
        </NavLink>
        <div className="desktop-nav">{links}</div>
        <div className="nav-actions">
          <NavLink className="cart-link" to="/cart" aria-label={`Cart, ${cart.count} item${cart.count === 1 ? "" : "s"}`}>
            <ShoppingCart size={19} strokeWidth={2.4} aria-hidden="true" />
            <span>{cart.count}</span>
          </NavLink>
          <Button to="/shop">Buy the eBook</Button>
          <button className="menu-button" type="button" aria-label="Toggle menu" onClick={() => setOpen((value) => !value)}>
            <span />
            <span />
          </button>
        </div>
      </nav>
      <AnimatePresence>
        {open && (
          <motion.div
            className="mobile-nav"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
          >
            {links}
          </motion.div>
        )}
      </AnimatePresence>
      {promoStrip.length > 0 && (
        <div className="promo-strip">
          {promoStrip.map((item, index) => (
            <span key={`${item}-${index}`}>{item}</span>
          ))}
        </div>
      )}
    </header>
  );
}
